export default {
  state: {
    isLoadingData: false,
    isLoadingStatic: false
  },

  mutations: {
    LOADING (state) {
      state.isLoadingData = true
    },

    LOADINGSTATIC (state) {
      state.isLoadingData = true
      state.isLoadingStatic = true
    },

    LOADED (state) {
      state.isLoadingData = false
      state.isLoadingStatic = false
    }
  },

  actions: {
    loadingData: ({ commit }) => {
      commit('LOADING')
    },

    loadingDataStatic: ({ commit }) => {
      commit('LOADINGSTATIC')
    },

    dataLoaded: ({ commit }) => {
      commit('LOADED')
    }
  },

  getters: {
    isLoadingData: state => state.isLoadingData,
    isLoadingStatic: state => state.isLoadingStatic
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/loading.js